import { useEffect, useState } from "react";
import { useAuth } from "../context/AuthProvider";
import { usePersistedState } from "../context/PersistedStateProvider";
import { isObjectTruthy } from "../utils";
import { admin_media_features, admin_user_features } from "../static";
// import { featuresAllowed } from "@/static/features";
export function useBuildPermittedNavigationLinks(features, projectId) {
  const [navigationLinks, setNavigationLinks] = useState({});
  const {
    user,
    featurePermissions,
    isAdmin,
    isMediaAdmin,
    isUserAdmin,
    metaData,
  } = useAuth();
  const { custom_projects: { permittedCustomProjects } = {} } =
    usePersistedState();

  useEffect(() => {
    try {
      // Available Features

      let af = JSON.parse(JSON.stringify(features));

      // Permitted Features
      let pf = {};

      if (user && isObjectTruthy(featurePermissions)) {
        const {
          is_media_enabled,
          is_faninsights_enabled,
          is_international_fan_insights_enabled,
          is_custom_projects_enabled,
        } = featurePermissions || {};

        // Allow homepage
        pf.home = { ...af.home };

        // Allow Admin Features
        if (user?.attributes) {
          // User is at least one type of Admin
          if (isAdmin || isMediaAdmin || isUserAdmin) {
            pf.admin = { ...af.admin };

            // Not a super admin
            if (!isAdmin) {
              pf.admin.items = pf.admin.items.filter(
                (feature) => feature.label !== "Question Map"
              );

              // Is a User Admin && Media Admin
              if (isUserAdmin && isMediaAdmin) {
                // Show all Admin Features
                pf.admin.items = pf.admin.items.filter((feature) =>
                  [...admin_user_features, ...admin_media_features].includes(
                    feature.label
                  )
                );
              }

              // Not a User Admin
              if (!isUserAdmin) {
                // Only show Organizations if User Admin
                pf.admin.items = pf.admin.items.filter(
                  (feature) => !admin_user_features.includes(feature.label)
                );
              }

              // Not a Media Admin
              if (!isMediaAdmin) {
                // Only show Media Sessions if Media Admin
                pf.admin.items = pf.admin.items.filter(
                  (feature) => !admin_media_features.includes(feature.label)
                );
              }
            }
          }
        }
        // Allow Fan Insights
        if (is_faninsights_enabled === true) {
          pf.fan_insights = { ...af.fan_insights };

          // if (metaData?.features?.Rankers === true || isAdmin === true)
          if (metaData?.features?.Rankers === true)
            pf.fan_rankers = { ...af.fan_rankers };
        }

        // Allow International Fan Insights
        if (is_international_fan_insights_enabled === true) {
          pf.international = { ...af.international_fan_insights };
        }

        // Allow Media
        if (is_media_enabled === true || isMediaAdmin === true) {
          pf.media = { ...af.media };
        }

        // Allow Custom Projects
        if (
          is_custom_projects_enabled === true &&
          permittedCustomProjects?.value.length > 0
        ) {
          // Map Custom Projects Links to Use Project Id

          pf.custom_projects = { ...af.custom_projects };
          if (pf.custom_projects && projectId) {
            pf.custom_projects = {
              ...pf.custom_projects,
              items: pf.custom_projects.items.map((item) => {
                return {
                  ...item,
                  path: item.path.replace(/{projectId}/g, `${projectId}`),
                };
              }),
            };
          }
        }

        const result = Object.entries(pf);

        let valueAdmin = result.find(([key]) => key === "admin");
        let indexAdmin = result.findIndex(([key]) => key === "admin");
        if (indexAdmin >= 1) {
          result.splice(indexAdmin, 1);
          result.push(valueAdmin);
        }

        setNavigationLinks(result);

        // Deprecated Jan 24, 2025
        // if (
        //   featurePermissions.is_media_enabled !== true &&
        //   isAdmin !== true &&
        //   isMediaAdmin !== true
        // ) {
        //   delete pf.media;
        // }
        // if (featurePermissions.is_faninsights_enabled !== true) {
        //   delete pf.fan_insights;
        // }
        // if (featurePermissions.is_international_fan_insights_enabled !== true) {
        //   delete pf.international;
        // } else {
        //   console.log(
        //     "featurePermissions.is_international_fan_insights_enabled",
        //     featurePermissions.is_international_fan_insights_enabled
        //   );
        // }
        // if (
        //   featurePermissions.is_custom_projects_enabled !== true ||
        //   permittedCustomProjects?.value.length === 0
        // ) {
        //   console.log("deleting cp", featurePermissions);
        //   delete pf.custom_projects;
        // }
        // else {
        //   console.log("building custom projects");
        //   // Add Custom Project Ids to Navigation Links
        //   if (projectId) {
        //     pf.custom_projects = {
        //       ...features["custom_projects"],
        //       items: [
        //         {
        //           label: "Reports",
        //           path: `/custom-projects/${projectId}/reports`,
        //         },
        //         {
        //           label: "Build Report",
        //           path: `/custom-projects/${projectId}/reports/new`,
        //         },
        //         {
        //           label: "Audiences",
        //           path: `/custom-projects/${projectId}/audiences`,
        //         },
        //         {
        //           label: "Build Audience",
        //           path: `/custom-projects/${projectId}/audiences/new`,
        //         },
        //       ],
        //     };
        //   }
        // }
      }

      // Deprecated Jan 24, 2025
      // if (user && user?.attributes) {
      //   // ========================================================
      //   // Remove definition of admin features if not any admin - better way to do this? Probably.
      //   // Patrick Fortaleza
      //   // ========================================================
      //   if (!isAdmin && !isMediaAdmin && !isUserAdmin) {
      //     // Delete Admin altogether
      //     delete pf.admin;
      //   } else {
      //     if (!isAdmin) {
      //       if (!isUserAdmin)
      //         // Only show Organizations if User Admin
      //         pf.admin.items = pf.admin.items.filter(
      //           (feature) => feature.label !== "Organizations"
      //         );

      //       if (!isMediaAdmin)
      //         // Only show Media Sessions if Media Admin
      //         pf.admin.items = pf.admin.items.filter(
      //           (feature) => feature.label !== "Media Sessions"
      //         );
      //     }
      //   }

      //   // IS THIS CODE BELOW EVEN NEEDED????
      //   //   // Remove f.admin if there are no items
      //   //   if (
      //   //    pf?.admin &&
      //   //     Array.isArray(pf.admin.items) &&
      //   //    pf.admin.items.length < 1
      //   //   ) {
      //   //     delete pf.admin;
      //   //   }
      //   // } else {
      //   //   pf["media"]["items"] = [
      //   //     {
      //   //       label: "Coming Soon",
      //   //       path: undefined,
      //   //     },
      //   //   ];

      //   delete pf.admin;
      // }
    } catch (error) {
      console.log("Error:", error);
    }

    // eslint-disable-next-line
  }, [projectId, featurePermissions, permittedCustomProjects, user]);

  return navigationLinks;
}
